import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { render_date } from 'utils';
import { FormattedMessage } from 'ui/i18n';

import './LeftSideCategory.scss';

@inject('UIState')
@observer
export default class LeftSideCategory extends Component {
	static propTypes = {
		UIState: PropTypes.object.isRequired,
		category: PropTypes.object.isRequired,
		promo_end_date: PropTypes.object.isRequired,
		promotionId: PropTypes.number.isRequired,
		selected: PropTypes.bool,
	};

	static defaultProps = {
		selected: false,
	};

	constructor(props) {
		super(props);

		this.props.UIState.saveCategory({
			id: this.props.category.id,
			select: this.selectCategory.bind(this),
		});
	}

	@observable selected = this.props.selected;

	@action
	selectCategory(select) {
		this.selected = select;
	}
	showEndDate(catEndDate, promoEndDate) {
		return catEndDate.isBefore(promoEndDate);
	}

	@action
	handleOnClick() {
		this.props.UIState.collapseOtherPromotions(this.props.promotionId);
		this.selected = true;
	}

	render() {
		const { category, promo_end_date, promotionId } = this.props;
		const selected = this.selected ? 'selected' : '';

		return (
			<div className="LeftSideCategory" onClick={this.handleOnClick.bind(this)}>
				<Link
					to={`/offerings?categoryId=${category.id}&promotionId=${promotionId}`}
					className={selected}
				>
					{category.name}
					{this.showEndDate(category.end_date, promo_end_date) &&
						<p className="LeftSideCategory__content__subtitle">
							<FormattedMessage id="itemsTable.endDateColumn" />{' '}
							{render_date(category.end_date)}
						</p>}
				</Link>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/LeftSideCategory/index.js